// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: linear-gradient(to bottom, #c2c1c2, #6f42d6);
  color: #fff;
}

.welcome-page h1 {
  font-size: 36px;
  margin-bottom: 10px;
}

.welcome-page p {
  font-size: 18px;
  margin-bottom: 30px;
}

.welcome-login-button {
  font-family: Plus Jakarta Sans;
  font-size: 18px !important;
  font-weight: 600 !important;
  line-height: 50px !important;
  letter-spacing: -0.004em;
  text-align: left !important;
  padding: 0px 20px 0px 20px !important;
  color: #564ffd !important;
  background-color: #ebebff !important;
  border-color: #ebebff !important;
  margin-top: 12px;
}

.welcome-login-button:hover {
  color: white !important;
  background-color: #564ffd !important;
}

.center-align {
  text-align: center;
}

.welcome-heading {
  margin-bottom: 10px !important;
}

.welcome-desc {
  padding: 4px 30px 0px 40px !important;
}

.tutoria-homepage .brand-mark {
  width: 44px;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #2b6ef6, #5cc5ff);
  color: white;
  border-radius: 8px;
  font-weight: 700;
}

.tutoria-homepage .brand-title {
  font-size: 2.05rem;
}

.tutoria-homepage .brand-sub {
  font-size: 0.7rem;
}

.hero {
  min-height: 68vh;
  display: flex;
  align-items: center;
  background-image: linear-gradient(to top, #e99fe9, #6f42d6);
  background-blend-mode: multiply, normal;
  padding: 4rem 0;
}

.hero .text-highlight {
  color: #ffd166;
}

.hero .lead {
  max-width: 820px;
  margin: 0 auto;
}

.hero .btn-cta {
  box-shadow: 0 8px 20px rgba(11, 66, 170, 0.18);
}

.hero-mini {
  border-radius: 10px;
}

.hero-cards .card {
  background: rgba(255, 255, 255, 0.95);
}

.service-card {
  border-radius: 12px;
}

.feature-card {
  border-radius: 12px;
  transition: all 0.18s ease;
}

.feature-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 10px 30px rgba(13, 38, 76, 0.08);
}

.feature-icon {
  font-size: 32px;
}

.motivational-banner {
  background-image: linear-gradient(to bottom, #e99fe9, #6f42d6);
  padding: 3.5rem 0;
}

footer a {
  text-decoration: none;
}

/* Custom modal */
.custom-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.custom-modal {
  width: 100%;
  max-width: 540px;
  padding: 1rem;
}

.custom-modal-content {
  background: white;
  border-radius: 10px;
  padding: 1.25rem;
  box-shadow: 0 20px 60px rgba(2, 6, 23, 0.2);
}

/* Responsive tweaks */
@media (max-width: 768px) {
  .hero {
    padding: 3rem 0;
  }
  .hero .display-5 {
    font-size: 1.6rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/WelcomePage/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,8DAAA;EACA,WAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,yBAAA;EACA,oCAAA;EACA,gCAAA;EACA,gBAAA;AACF;;AAEA;EACE,uBAAA;EACA,oCAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,qCAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qDAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AACA;EACE,kBAAA;AAEF;;AAAA;EACE,iBAAA;AAGF;;AAAA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,2DAAA;EACA,uCAAA;EACA,eAAA;AAGF;;AADA;EACE,cAAA;AAIF;;AAFA;EACE,gBAAA;EACA,cAAA;AAKF;;AAHA;EACE,8CAAA;AAMF;;AAHA;EACE,mBAAA;AAMF;;AAJA;EACE,qCAAA;AAOF;;AAJA;EACE,mBAAA;AAOF;;AALA;EACE,mBAAA;EACA,0BAAA;AAQF;;AANA;EACE,2BAAA;EACA,8CAAA;AASF;;AAPA;EACE,eAAA;AAUF;;AAPA;EACE,8DAAA;EACA,iBAAA;AAUF;;AAPA;EACE,qBAAA;AAUF;;AAPA,iBAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAUF;;AARA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;AAWF;;AATA;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,2CAAA;AAYF;;AATA,sBAAA;AACA;EACE;IACE,eAAA;EAYF;EAVA;IACE,iBAAA;EAYF;AACF","sourcesContent":[".welcome-page {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-image: linear-gradient(to bottom, #c2c1c2, #6f42d6);\n  color: #fff;\n}\n\n.welcome-page h1 {\n  font-size: 36px;\n  margin-bottom: 10px;\n}\n\n.welcome-page p {\n  font-size: 18px;\n  margin-bottom: 30px;\n}\n\n.welcome-login-button {\n  font-family: Plus Jakarta Sans;\n  font-size: 18px !important;\n  font-weight: 600 !important;\n  line-height: 50px !important;\n  letter-spacing: -0.004em;\n  text-align: left !important;\n  padding: 0px 20px 0px 20px !important;\n  color: #564ffd !important;\n  background-color: #ebebff !important;\n  border-color: #ebebff !important;\n  margin-top: 12px;\n}\n\n.welcome-login-button:hover {\n  color: white !important;\n  background-color: #564ffd !important;\n}\n\n.center-align {\n  text-align: center;\n}\n\n.welcome-heading {\n  margin-bottom: 10px !important;\n}\n\n.welcome-desc {\n  padding: 4px 30px 0px 40px !important;\n}\n\n.tutoria-homepage .brand-mark {\n  width: 44px;\n  height: 44px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #2b6ef6, #5cc5ff);\n  color: white;\n  border-radius: 8px;\n  font-weight: 700;\n}\n.tutoria-homepage .brand-title {\n  font-size: 2.05rem;\n}\n.tutoria-homepage .brand-sub {\n  font-size: 0.7rem;\n}\n\n.hero {\n  min-height: 68vh;\n  display: flex;\n  align-items: center;\n  background-image: linear-gradient(to top, #e99fe9, #6f42d6);\n  background-blend-mode: multiply, normal;\n  padding: 4rem 0;\n}\n.hero .text-highlight {\n  color: #ffd166;\n}\n.hero .lead {\n  max-width: 820px;\n  margin: 0 auto;\n}\n.hero .btn-cta {\n  box-shadow: 0 8px 20px rgba(11, 66, 170, 0.18);\n}\n\n.hero-mini {\n  border-radius: 10px;\n}\n.hero-cards .card {\n  background: rgba(255, 255, 255, 0.95);\n}\n\n.service-card {\n  border-radius: 12px;\n}\n.feature-card {\n  border-radius: 12px;\n  transition: all 0.18s ease;\n}\n.feature-card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 10px 30px rgba(13, 38, 76, 0.08);\n}\n.feature-icon {\n  font-size: 32px;\n}\n\n.motivational-banner {\n  background-image: linear-gradient(to bottom, #e99fe9, #6f42d6);\n  padding: 3.5rem 0;\n}\n\nfooter a {\n  text-decoration: none;\n}\n\n/* Custom modal */\n.custom-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1050;\n}\n.custom-modal {\n  width: 100%;\n  max-width: 540px;\n  padding: 1rem;\n}\n.custom-modal-content {\n  background: white;\n  border-radius: 10px;\n  padding: 1.25rem;\n  box-shadow: 0 20px 60px rgba(2, 6, 23, 0.2);\n}\n\n/* Responsive tweaks */\n@media (max-width: 768px) {\n  .hero {\n    padding: 3rem 0;\n  }\n  .hero .display-5 {\n    font-size: 1.6rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
